import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'

const ErrorStep = props => (
  <div className='bg-white radius row px-1 mx-0 pt-2 pb-3 border-top-lg border-color-error'>
    <div className='row px-1 mx-0'>
      <div className='col-10'>
        <p className='txt-body my-1'>
          <i className='icon icon_close_circle color-error' />
        </p>
      </div>
      <div className='col-2 pl-3'>
        <i
          className='icon icon_close txt-body-sm cursor'
          onClick={props.resetSteps}
        />
      </div>
      <div className='col-12'>
        <p className='txt-body my-1 color-error'>{props.title}</p>
        <p className='txt-body-sm my-1'>{props.errorMessage}</p>
      </div>
      <div className='col-12 mt-1 mb-5 pb-5'>
        <Button
          id={'btnTryAgainRecharge'}
          name={'TryAgainRecharge'}
          className='btn-featured btn btn-sm btn-cart mb-5'
          text='TENTAR NOVAMENTE'
          onClick={props.tryAgain}
        />
      </div>
    </div>
  </div>
)

ErrorStep.propTypes = {
  errorMessage: PropTypes.string,
  tryAgain: PropTypes.func,
  resetSteps: PropTypes.func,
  title: PropTypes.string
}

export default ErrorStep



// WEBPACK FOOTER //
// ./src/features/Services/RechargePhone/ErrorStep.js